import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { REHYDRATE } from 'redux-persist/lib/constants';
import Candidate from './candidateReducer';
import Position from './positionReducer';
import Question from './questionReducer';
import Dashboard from './dashboardReducer';
import Profile from './profileReducer';
// [INC-1880] `userPermissionList` is the sub-user's live role permissions. The root
// persistConfig stored the whole tree, so at boot redux-persist rehydrated the copy written
// during the PREVIOUS session and MainPage's redirect guard ran against it before the fresh
// GET users/permissions landed: a product the employer had just re-enabled still read
// status:false, and the sub-user was bounced back out to account/product every time. The
// guard already no-ops on an empty list (`find` returns undefined), so excluding this one
// field is enough — no extra flag needed. Employers never reach it; the API returns [] for
// them and every caller short-circuits on userType === 'employer'.
// Root must blacklist `Profile` too: the blob earlier builds wrote still holds the field, and
// the root rehydrate would put it straight back before this nested config ever applied.
const profilePersistConfig = {
    key: 'Profile',
    storage,
    blacklist: ['userPermissionList'],
};

const appReducer = combineReducers({
    Candidate,
    Position,
    Question,
    Dashboard,
    Profile: persistReducer(profilePersistConfig, Profile),
});

// [INC-1880] The blacklist above is NOT enough on its own. redux-persist applies
// blacklist/whitelist in createPersistoid only, i.e. when WRITING; getStoredState and
// autoMergeLevel1 never filter on READ. So the blob earlier builds wrote still carries
// userPermissionList and rehydrates it straight back at boot, which is exactly the
// window in which MainPage's redirect guard runs. Strip it from every REHYDRATE payload
// as well - `key` is 'root' for the legacy blob (slice nested under Profile) and
// 'Profile' for the nested config, so both shapes have to be handled.
const stripPersistedPermissions = (action) => {
    if (action.type !== REHYDRATE || !action.payload) return action;
    if (action.key === 'Profile') {
        return { ...action, payload: { ...action.payload, userPermissionList: null } };
    }
    if (action.payload.Profile) {
        return {
            ...action,
            payload: { ...action.payload, Profile: { ...action.payload.Profile, userPermissionList: null } },
        };
    }
    return action;
};

const reducers = (state, action) => {
    return appReducer(state, stripPersistedPermissions(action));
};

export default reducers;
